import { render, staticRenderFns } from "./EventDesc.vue?vue&type=template&id=1069f56c&scoped=true&"
import script from "./EventDesc.vue?vue&type=script&lang=js&"
export * from "./EventDesc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1069f56c",
  null
  
)

export default component.exports